import { render } from "./coursewareList.vue?vue&type=template&id=f8032fe8&scoped=true"
import script from "./coursewareList.vue?vue&type=script&lang=js"
export * from "./coursewareList.vue?vue&type=script&lang=js"

import "./coursewareList.vue?vue&type=style&index=0&id=f8032fe8&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8032fe8"]])

export default __exports__